export default __webpack_public_path__ + "static/media/BgMiniMap.6a93fbd1.svg";